import React from "react"
import { makeStyles } from "@material-ui/core/styles"
import { Paper } from "@material-ui/core"

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: "#e9e9e9",
    padding: theme.spacing(3),
    marginBottom: theme.spacing(2),
  },
  paper: {
    padding: theme.spacing(2),
  },
}))

const LreReactLayout = props => {
  const classes = useStyles()
  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>{props.children}</Paper>
    </div>
  )
}

export default LreReactLayout
